import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import '../../../packs/tinymce';

application.register(
  'tinymce',
  class extends Controller {
    connect() {
      tinymce.init({
        selector: '.tinymce',
        height: 500,
        skin: false,
        content_css: false,
        plugins: [
          'advlist lists link image anchor',
          'table paste wordcount help'
        ],
        toolbar: 'undo redo | formatselect | ' +
          'bold italic backcolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          ' removeformat | image | help'
      });
    }
  }
)
